import { render, staticRenderFns } from "./DeleteToast.vue?vue&type=template&id=73a15096&scoped=true&"
import script from "./DeleteToast.vue?vue&type=script&lang=ts&"
export * from "./DeleteToast.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a15096",
  null
  
)

export default component.exports